import React from 'react';
import { Loader2 } from 'lucide-react';

// Enhanced loading fallback component with status message
const LoadingFallback = ({ message }: { message?: string }) => (
  <div className="flex flex-col h-screen w-screen items-center justify-center">
    <Loader2 className="h-8 w-8 animate-spin mb-4" />
    {message && <p className="text-sm text-gray-500">{message}</p>}
  </div>
);

export default LoadingFallback; 